/* eslint-disable implicit-arrow-linebreak */
import { RouteConfig } from 'vue-router';

import { multiGuard } from '../Middleware/MultiGuard';

import { permissionQuestion, permissionQuestionList } from '../Middleware/permission/Question';

import { onboardingQuestions } from '../Middleware/onboarding/index';

export const NAME_ROUTES_QUESTIONS = {
  LIST: 'ListQuestions',
  TUTORIAL: 'TutorialQuestions',
  ANSWER: 'AnswerQuestion'
};

export const Questions: Array<RouteConfig> = [
  {
    path: '/questoes',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_QUESTIONS.LIST,
        component: () =>
          import(/* webpackChunkName: "questions" */ '@/pages/Question/Question.vue'),
        meta: { title: 'Lista de Questões' },
        beforeEnter: multiGuard([permissionQuestionList, onboardingQuestions])
      },
      {
        path: 'tutorial',
        name: NAME_ROUTES_QUESTIONS.TUTORIAL,
        component: () =>
          import(
            // eslint-disable-next-line
            /* webpackChunkName: "questions-tutorial" */ '@/pages/Question/pages/TutorialQuestions/TutorialQuestions.vue'
          ),
        meta: { title: 'Tutorial Questões' }
      }
    ]
  },
  {
    path: '/questao/:id',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_QUESTIONS.ANSWER,
        component: () =>
          import(
            // eslint-disable-next-line
            /* webpackChunkName: "questions-show" */ '@/pages/Question/pages/AnswerQuestion/AnswerQuestion.vue'
          ),
        meta: { title: 'Responder Questão' },
        beforeEnter: multiGuard([permissionQuestion]) 
      }
    ]
  }
];
